export default __webpack_public_path__ + "static/media/3.7e9927b2.png";